// Same day thresholds as Sencha's PanelActividades; ERP dates are local days.
export function seguimientoDeadline(value, now = new Date()) {
  const match = /^(\d{4})-(\d{2})-(\d{2})(?:$|[T ])/.exec(String(value || ''));
  const neutral = { tone: 'sin-fecha', label: 'Sin fecha' };
  if (!match) return neutral;
  const [, y, m, d] = match.map(Number);
  const due = new Date(y, m - 1, d);
  if (due.getFullYear() !== y || due.getMonth() !== m - 1 || due.getDate() !== d) return neutral;
  // Compare calendar days, including across month/year and DST boundaries.
  const days = Math.round((Date.UTC(y, m - 1, d) - Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
  if (days < 0) return { tone: 'vencido', label: 'Vencido' };
  if (days <= 2) return { tone: 'por-vencer', label: days === 0 ? 'Vence hoy' : 'Por vencer' };
  return { tone: 'vigente', label: 'Vigente' };
}
